module.exports = '<svg width="28" height="32" viewBox="0 0 28 32"><path d="M22 0v11.312c0 .552-.374.752-.832.446L19 9.574l-2.168 2.184c-.458.306-.832.108-.832-.446V0H6C2.68 0 0 2.68 0 6v20c0 3.32 2.68 6 6 6h20c1.106 0 2-.894 2-2V2c0-1.106-.894-2-2-2h-4zM6 28c-1.1 0-2-.9-2-2s.9-2 2-2h18v4H6z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/book-5.js
// module id = 1018
// module chunks = 14